import { Button, HStack, Spacer, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { useEffect, useState } from "react";
import { AddTokenButton } from "../AddTokenButton/AddTokenButton";
import { ConnectWalletButton } from "../ConnectWalletButton/ConnectWalletButton";
import { Logo } from "../Logo";

export const Nav = () => {
  return (
    <HStack w="full" p={5} bgGradient='linear(90deg, rgba(9,9,9,0.7317051820728291) 0%, rgba(2,2,6,0.4459908963585434) 42%)'>
      <a href="https://aarya.network"> {/* Add the anchor tag here */}
        <Logo />
      </a>
      <Spacer />
      <AddTokenButton />
      <ConnectWalletButton />
    </HStack>
  );
};
